import React from "react";
import type { PriceSearchItem } from "../sp/portalSearchTypes";

type Props = {
  item: PriceSearchItem;
};

// NOTE: ラベルは表示中の見出しに合わせ「費用」（item.title は i18n 上「予算」のため使わない）
function PortalPCPriceField({ item }: Props) {
  return (
    <div className="portalPcSelectControl">
      <select
        className="portalPcSelect"
        aria-label="費用"
        value={item.priceId || ""}
        onChange={(e) => item.setPriceId(e.target.value)}
      >
        <option value="">選択してください</option>
        {item.items.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default PortalPCPriceField;
